import { render } from "./PersonalMenu.vue?vue&type=template&id=10e59b66&scoped=true"
const script = {}

import "./PersonalMenu.vue?vue&type=style&index=0&id=10e59b66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e59b66"]])

export default __exports__